import Api from '../global/api';

export function login (fields) {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'USER_LOGIN',
            status: 'loading',
            payload: null
        })

        Api.req('user', 'POST', fields).then(
            async res => {

                Api.setLocal(process.env.REACT_APP_TOKEN || 'rt', res.result.token);

                // Login successful
                dispatch({
                    type: 'USER_LOGIN',
                    status: 'in',
                    payload: res.result
                })
            },
            err => {
                // Login error
                dispatch({
                    type: 'USER_LOGIN',
                    status: 'error',
                    payload: typeof err.msg === 'string' ? err.msg : 'Sorry we were unable to log you in'
                })
            }
        )
    }
}

export function userValidate () {
    return async dispatch => {

        dispatch({
            type: 'USER_VERIFYING',
            payload: true
        })

        const token = await Api.getLocal(process.env.REACT_APP_TOKEN || 'rt');
        if(typeof token === 'undefined' || token === null)
            dispatch({
                type: 'USER_LOGOUT',
                payload: null
            })
        else {

            Api.req('user', 'GET', null, {'x-access-token': token}).then(
                async res => {

                    Api.setLocal(process.env.REACT_APP_TOKEN || 'rt', res.result.token);

                    // Login successful
                    dispatch({
                        type: 'USER_LOGIN',
                        status: 'in',
                        payload: res.result
                    })
                },
                err => {
                    // Login error
                    dispatch({
                        type: 'USER_LOGOUT',
                        payload: null
                    })
                }
            )

        }
    }
}

export function logout () {

    return async dispatch => {

        //  Removed the current active profile, 
        //  this will save bugs when another person logs in
        await localStorage.removeItem(process.env.REACT_APP_TOKEN || 'rt');

        // Logout successful
        dispatch({
            type: 'USER_LOGOUT',
            payload: null
        })

    }

}